import * as React from 'react';
import Box from '@mui/material/Box';

import {useEffect, useState} from "react";
import {
    CardContent, Container,
    FormControl, FormLabel,
    InputLabel, Link,
    MenuItem,
    Select, SvgIcon, Tooltip, Typography
} from "@mui/material";
import {useGetUserDetailsQuery, useSetUserLocationMutation} from "../../core/api/users-api";
import LinkTabs from "../Common/LinkTabs";
import {Outlet, useLocation, useNavigate} from "react-router";
import {getTabMainState, getTabState} from "../../core/utils/utils";
import {store} from "../../core/utils/configureStore";
import {COUNTRIES} from "../../constants";
import ButtonBase from "@mui/material/ButtonBase";
import ErrorBox from "../Common/ErrorBox";
import {useSelector} from "react-redux";
import ProductPrice from "../Common/PriceComponent";
import {useCheckVoucherQuery} from "../../core/api/seniority-api";

import { ReactComponent as SenioritySvg } from "../../img/seniority.svg";
import XpWidget from "../Experience/XpWidget";

const SeniorityIcon = (props) => (
    <SvgIcon {...props} component={SenioritySvg} viewBox="0 0 64 64" />
);

const MenuProps = {
    PaperProps: {
        sx: {
            maxWidth: "fit-content"
        },
    },
};


export default function MainTabs() {
    const {data: response = [], error: errors = {}, isError} = useGetUserDetailsQuery();

    //const {data: voucher, isSuccess} = useCheckVoucherQuery();
    const [setLocation] = useSetUserLocationMutation()
    const location = useLocation();
    const [state, setState] = useState({
        userLocation: "",
        errorData: "Access denied",
        userHasSeniorityVoucher: response.hasSeniorityVoucher
    })
    const sessionState = useSelector((state) => state.data.UserSession)
    const isUserHasAdminRole = sessionState.user.isAdmin;
    const isUserHasManagerRole = sessionState.user.isManager;

    const navigate = useNavigate();
    let adminLocation = location.pathname.includes("admin");
    let presentLocation = location.pathname.includes("present");

    useEffect(() => {
        if (!response) return;

       if (!isError) {
           setState({
                ...state,
               userHasSeniorityVoucher: response.hasSeniorityVoucher,
               userLocation: response.location
            })
            changeSessionEmployeeInfo(response);
        } else {
            setState({
                ...state,
                userHasSeniorityVoucher: response.hasSeniorityVoucher,
                errorData: errors?.data?.error || "Access denied"
            })
        }

    }, [response?.hasSeniorityVoucher, response?.location, isError, errors?.data?.error]);


    const changeSessionEmployeeInfo = (employeeInfo) => {
        store.dispatch({
            type: 'USER_INFO_CHANGE', payload: {
                data: {
                    fullName: employeeInfo.fullName,
                    location: employeeInfo.location,
                    phone: employeeInfo.phone,
                    balance: employeeInfo.balance,
                    hasSeniority: employeeInfo.hasSeniorityVoucher
                }
            }
        })
    }

    const handleLocationChange = (event) => {
        const newLocation = event.target.value;
        setState({
            ...state,
            userLocation: newLocation
        })

        setLocation({
            location: newLocation
        })

        store.dispatch({
            type: 'LOCATION_CHANGE', payload: {
                data: {
                    location: newLocation
                }
            }
        })
    }

    const handleBalanceClick = () => {
        navigate('/balance');
    }
    return (
        isError ?
            <ErrorBox
                error={state.errorData
                }/> :
            <Box>

            <Container className={"navbar-container"}>
                <Box className="navbar" sx={{
                    pt: { xs: 1.5, sm: 3 },
                    pb: { xs: 1.5, sm: 2 },
                    borderBottom: 0,
                    borderColor: 'divider',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: { xs: 'center', sm: 'space-between' },
                    flexWrap: 'wrap',
                    rowGap: 1,
                }}>
                    {state.userHasSeniorityVoucher && <Link
                        component={ButtonBase}
                        onClick={() => navigate('/seniority')}
                        sx={{
                            borderRadius: '50%',
                            minWidth: { xs: '52px', sm: '62px' },
                            height: { xs: '52px', sm: '62px' },
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '8px',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.04)'
                            }
                        }}
                    >
                        <SeniorityIcon color="primary" sx={{
                            width: { xs: '38px', sm: '46px' },
                            height: { xs: '38px', sm: '46px' },
                            color:'#853088'
                        }} />
                    </Link>}
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        rowGap: 1,
                        columnGap: { xs: 1, sm: 2 },
                        flex: 1,
                    }}>
                        <Box className="navbar__balance">
                            <Tooltip title="Your belcoin balance">
                                <Box onClick={handleBalanceClick}>
                                    <ProductPrice price={response.balance ? response.balance : "0"}/>
                                </Box>
                            </Tooltip>
                        </Box>

                        <FormControl className="navbar__location" sx={{ minWidth: 140, maxWidth: 200 }}>
                            <Select
                                color="warning"
                                labelId="location-select-label"
                                id="location-select"
                                value={state.userLocation ? state.userLocation : ''}
                                onChange={handleLocationChange}
                                MenuProps={MenuProps}
                                size={"small"}
                                sx={{
                                    borderRadius: '20px',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderRadius: '20px',
                                    }
                                }}
                            >
                                {COUNTRIES.map((option, index) => (
                                    <MenuItem key={`location_select_image_${index}`}
                                              value={option}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <Box>
                            <XpWidget />
                        </Box>
                    </Box>
                </Box>

            </Container>

                {(adminLocation || presentLocation) ?
                    <Container maxWidth={false}>
                    <Outlet/>
                </Container>:
                    <Container>
                        <Outlet/>
                    </Container>
                }


            </Box>
    );
}